import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Form, Input, Button } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Formik } from "formik";
import * as yup from "yup";
import { LoginBackground } from "styled/common-styled";
import { checkLogin } from "../actions";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

class Login extends PureComponent {
  state = {
    username: "",
    password: "",
  };

  renderForm() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.state}
        validationSchema={yup.object().shape({
          username: yup.string().required(" Username is required"),
          password: yup.string().required(" Password is required"),
        })}
        onSubmit={(values) => {
          this.props.checkLogin(values);
        }}
        render={({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form
            {...layout}
            layout="vertical"
            name="basic"
            initialValues={{ remember: true }}
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Username"
              name="username"
              required={true}
              validateStatus={touched.username && errors.username ? "error" : undefined}
              help={touched.username && errors.username ? errors.username : undefined}
            >
              <Input
                name="username"
                values={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Username"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              required={true}
              validateStatus={touched.password && errors.password ? "error" : undefined}
              help={touched.password && errors.password ? errors.password : undefined}
            >
              <Input.Password
                type="password"
                name="password"
                values={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                htmlType="submit"
                className="login-btn login-btn-primary"
                loading={this.props.auth.loading}
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
        )}
      />
    );
  }

  render() {
    const { auth } = this.props;
    const errorMsg = auth.status === "error" ? auth.msg : "";
    const errorAlert = errorMsg && (
      <div className="login-alert" role="alert">
        <ExclamationCircleFilled />
        <div>{errorMsg}</div>
      </div>
    );

    // noLayout: ใช้ใน OauthLogin (/loginqc) ซึ่งครอบ LoginBackground ไว้แล้ว
    if (this.props.noLayout) {
      return (
        <>
          {errorAlert}
          {this.renderForm()}
        </>
      );
    }

    return (
      <LoginBackground>
        <div className="login-brand">
          <div className="login-logo">
            <img src="/img/smartquality2-web-red.png" alt="SmartQuality" />
          </div>
          <h2 className="login-title">Sign in to System</h2>
        </div>

        <div className="login-card-wrapper">
          <div className="login-card">
            {errorAlert}
            {this.renderForm()}
          </div>
        </div>
      </LoginBackground>
    );
  }
}

export default connect(({ profile, auth }) => ({ profile, auth }), {
  checkLogin: checkLogin.request,
})(Login);
